import { defineComponent } from 'vue'
interface ComponentConfig {
  CommonMarkdownTagWrapper?: any
  CommonMarkdownBlock?: any
}
export default defineComponent({
  name: 'BaseMarkdownCtx',
  props: {
    content: String
  },
  setup(props) {
    const tagRegExp = /<pre><code class="language-tag">([\s\S]*?)<\/code><\/pre>/g
    const blockRegExp = /<pre><code class="language-block">([\s\S]*?)<\/code><\/pre>/g
    const jsonRegExp = /<json>([\s\S]*?)<\/json>/g
    const components: ComponentConfig = {
      CommonMarkdownTagWrapper: resolveComponent('CommonDocumentTagWrapper'),
      CommonMarkdownBlock: resolveComponent('BaseMarkdownBlockly')
    }
    const newContent = computed(() => {
      const ctx = props.content
        ?.replace(tagRegExp, (_, p1) => {
          return `<json>{"CommonMarkdownTagWrapper": ${p1.trim().replace(/\n/g, '')}}</json>`.replace(/&quot;/g, '"')
        })
        .replace(blockRegExp, (_, p1) => {
          return `<json>{"CommonMarkdownBlock": ${p1.trim().replace(/\n/g, '')}}</json>`.replace(/&quot;/g, '"')
        })
      return ctx?.split(jsonRegExp)
    })
    function isJSON(str: string) {
      try {
        JSON.parse(str)
      } catch (e) {
        return false
      }
      return true
    }

    return () => (
      <article>
        {newContent.value?.map((item) => {
          if (isJSON(item)) {
            const json = JSON.parse(item) as ComponentConfig
            const key = Object.keys(json)[0] as keyof ComponentConfig
            return h(components[key], { data: json[key] })
          }
          return <div class={'app-markdown-ctx'} innerHTML={item}></div>
        })}
      </article>
    )
  }
})
